import { StyleSheet, Dimensions } from 'react-native';

const { width } = Dimensions.get('window');

export default StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 60,
        paddingHorizontal: 20,
        flexGrow: 1,
        backgroundColor: '#fff',
    },
    image: {
        width: 260,
        height: 260,
        marginBottom: 30,
    },
    title: {
        fontSize: width > 768 ? 20 : 18,
        fontWeight: 'bold',
        color: '#ff6600',
        textAlign: 'center',
        marginBottom: 10,
        paddingHorizontal: 10,
    },
    subtext: {
        width: width > 768 ? '30%' : '80%',
        fontSize:  14,
        color: '#8c8c8c',
        marginBottom: 30,
        textAlign: 'center',
    },
    linkText: {
        fontSize:  14,
        color: '#ff6600',
        marginBottom: 30,
        textAlign: 'center',
    },
    button: {
        backgroundColor: '#ff6600',
        paddingVertical: 14,
        paddingHorizontal: 30,
        borderRadius: 12,
        marginTop: 10,
        width: width > 768 ? 350 : '60%',
        alignItems: 'center',
    },
    buttonText: {
        color: '#fff',
        fontWeight: 'bold',
        fontSize: 14,
    },
});
